import React from 'react';
import {Heading} from '../../components/guide/Heading';
import HeroBanner from "../../components/guide/HeroBanner";
import BannerImg from "../../assets/images/banner/guide_banner_6.png";
import GoogleAdImg from "../../assets/images/ad/google_ad.png";
import KakaoAdImg from "../../assets/images/ad/kakao_ad.png";
import NaverAdImg from "../../assets/images/ad/naver_ad.png";
import CtaBanner from "../../components/guide/CtaBanner";
import HeaderPath from "../../components/common/HeaderPath";

const PlacementsGuidePage: React.FC = () => (
    <section className="w-full bg-white">
        <div className="mx-auto w-full max-w-[1072px] px-0 sm:px-6 lg:px-0">
            <HeaderPath path={'> 광고 게재 위치'}/>
            <HeroBanner image={BannerImg} message="미분양 브랜딩부터, 완판 성공까지!"/>
            <Heading className="hidden lg:block lg:mt-[93px] lg:mb-[96px]" as="h1" size="h1">
                광고 게재 위치
            </Heading>
            <div className="mt-0 flex flex-col gap-12 sm:gap-16 lg:mt-0 lg:gap-[93px]">
                <Heading as="p" size="subtitle" className="text-black font-[400] leading-relaxed">
                    분양의신은 전국 5만 5천여 개 사이트 네트워크를 기반으로, 모바일과 PC 전 영역에서 광고가 단순히 노출되는 수준을
                    넘어,<br className={'hidden md:block'}/>
                    핵심 타겟에게 반복적으로 도달하도록 설계함으로써 효율적인 성과를 보장합니다.
                </Heading>

                <div>
                    <h5 className="text-[20px] font-[700] text-black sm:text-[25px]">구글 [GOOGLE]</h5>
                    <div className="px-4 md:x-0 my-4 flex items-center justify-center  bg-[#F1F3F5] py-10 sm:py-[73px]">
                        <img src={GoogleAdImg} alt="구글 광고 게재 예시" className="h-auto max-w-full" />
                    </div>
                    <ul className="space-y-1 pl-5 text-base font-[400] text-black list-disc sm:text-[18px]">
                        <li>
                            디스플레이 광고 (지메일MO·기사MO·구글 메인MO)
                        </li>
                        <li>
                            검색광고 (구글 검색지면 PC, 유튜브 검색 PC)
                        </li>
                        <li>
                            영상광고 (유튜브 인스트림, 범퍼애드, 인피드MO)
                        </li>
                    </ul>
                </div>
                <div>
                    <h5 className="text-[20px] font-[700] text-black sm:text-[25px]">카카오·다음 [KAKAO·DAUM]</h5>
                    <div className="px-4 md:x-0 my-4 flex items-center justify-center  bg-[#F1F3F5] py-10 sm:py-[73px]">
                        <img src={KakaoAdImg} alt="카카오와 다음 광고 지면 예시" className="h-auto max-w-full" />
                    </div>
                    <ul className="space-y-1 pl-5 text-base font-[400] text-black list-disc sm:text-[18px]">
                        <li>
                            디스플레이 광고 (다음 MO, 카카오 MO)
                        </li>
                        <li>
                            비즈보드 (카카오 MO)
                        </li>
                        <li>
                            검색광고 (다음 PC)
                        </li>
                    </ul>
                </div>
                <div>
                    <h5 className="text-[20px] font-[700] text-black sm:text-[25px]">네이버 [NAVER]</h5>
                    <div className="px-4 md:x-0 my-4 flex items-center justify-center  bg-[#F1F3F5] py-10 sm:py-[73px]">
                        <img src={NaverAdImg} alt="네이버 광고 지면 예시" className="h-auto max-w-full" />
                    </div>
                    <ul className="space-y-1 pl-5 text-base font-[400] text-black list-disc sm:text-[18px]">
                        <li>
                            GFA 디스플레이 광고 (MO지면, PC지면)
                        </li>
                        <li>
                            검색광고 파워링크 (MO지면, PC지면)
                        </li>
                        <li>
                            브랜드검색광고 (MO지면, PC지면)
                        </li>
                        <li>
                            롤링보드 (MO지면)
                        </li>
                    </ul>
                </div>

                <CtaBanner
                    message="우리 광고도 이런 지면에 나갈 수 있을까요?"
                    buttonText="광고문의 바로가기 →"
                    href="https://분양의신.net/contact"
                />
            </div>
        </div>
    </section>
);

export default PlacementsGuidePage;
